import { useEffect, useState } from "react";
import { navItems } from "@/mocks/drama";

export default function SiteNavbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [active, setActive] = useState("overview");

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
      const offset = window.scrollY + 140;
      let current = navItems[0].id;
      navItems.forEach((item) => {
        const el = document.getElementById(item.id);
        if (el && el.offsetTop <= offset) {
          current = item.id;
        }
      });
      setActive(current);
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navColor = scrolled ? "text-foreground-700" : "text-background-100";
  const activeColor = scrolled ? "text-primary-600" : "text-accent-400";

  return (
    <>
      {/* 顶部更新条 */}
      <div className="w-full bg-foreground-950 text-background-100">
        <div className="mx-auto flex h-9 max-w-[1280px] items-center justify-between gap-3 px-4 md:px-6">
          <p className="flex items-center gap-2 truncate text-xs md:text-[13px]">
            <i className="ri-flashlight-fill text-accent-400" />
            <span className="truncate">
              最新更新 · 大结局章节解析与人物结局线索已整理上线
            </span>
          </p>
          <a
            href="#latest"
            className="hidden shrink-0 items-center gap-1 text-xs text-accent-400 transition hover:text-accent-300 sm:flex"
          >
            前往最新剧情
            <i className="ri-arrow-right-s-line" />
          </a>
        </div>
      </div>

      <header
        className={`sticky top-0 z-50 w-full transition-all duration-300 ${
          scrolled
            ? "border-b border-background-200/80 bg-background-50/90 backdrop-blur-md"
            : "border-b border-transparent bg-transparent"
        }`}
      >
        <div className="mx-auto flex h-16 max-w-[1280px] items-center justify-between px-4 md:px-6">
          <a
            href="#top"
            className={`flex items-center gap-2.5 font-heading text-lg font-bold tracking-wide transition ${
              scrolled ? "text-foreground-950" : "text-background-50"
            }`}
          >
            <span
              className={`flex h-8 w-8 items-center justify-center rounded-md ${
                scrolled ? "bg-primary-500 text-background-50" : "bg-primary-500 text-background-50"
              }`}
            >
              <i className="ri-quill-pen-line" />
            </span>
            欲望的诱惑
          </a>

          <nav className="hidden items-center gap-1 lg:flex">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                className={`rounded-md px-3 py-2 text-sm font-medium transition ${
                  active === item.id ? activeColor : `${navColor} hover:opacity-80`
                }`}
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href="#ending"
              className="hidden items-center gap-1 rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition hover:bg-primary-600 md:inline-flex"
            >
              看大结局解析
              <i className="ri-arrow-down-line" />
            </a>
            <button
              type="button"
              aria-label="打开导航菜单"
              onClick={() => setMenuOpen((v) => !v)}
              className={`flex h-10 w-10 items-center justify-center rounded-md text-xl transition lg:hidden ${
                scrolled ? "text-foreground-900 hover:bg-background-200" : "text-background-50 hover:bg-white/10"
              }`}
            >
              <i className={menuOpen ? "ri-close-line" : "ri-menu-line"} />
            </button>
          </div>
        </div>

        {menuOpen && (
          <div className="border-t border-background-200 bg-background-50 lg:hidden">
            <nav className="mx-auto grid max-w-[1280px] grid-cols-2 gap-1 px-4 py-3">
              {navItems.map((item) => (
                <a
                  key={item.id}
                  href={`#${item.id}`}
                  onClick={() => setMenuOpen(false)}
                  className={`rounded-md px-3 py-2.5 text-sm ${
                    active === item.id
                      ? "bg-primary-100 font-medium text-primary-700"
                      : "text-foreground-700 hover:bg-background-100"
                  }`}
                >
                  {item.label}
                </a>
              ))}
            </nav>
          </div>
        )}
      </header>
    </>
  );
}